export const COMPANY_LOGO_URL = `${process.env.PUBLIC_URL || ""}/logo.png`;
export const COMPANY_NAME = "myrealestate-ng.com";
